import { createFileRoute } from '@tanstack/react-router';
import { RequirePermission } from '../../../features/layout/RequirePermission';
import { z } from 'zod';
import { FacilitiesPage } from '../../../features/admin/facilities/FacilitiesPage';

const searchSchema = z.object({
  q: z.string().catch(''),
  page: z.number().int().min(1).catch(1),
  clusterId: z.number().int().positive().optional().catch(undefined),
  active: z
    .preprocess((v) => (typeof v === 'boolean' ? String(v) : v), z.enum(['all', 'true', 'false']))
    .catch('all'),
});

export const Route = createFileRoute('/_authed/admin/facilities')({
  validateSearch: searchSchema,
  component: Guarded,
});

function FacilitiesRoute(): React.JSX.Element {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <FacilitiesPage search={search} onSearch={(next) => void navigate({ search: next })} />;
}

function Guarded(): React.JSX.Element {
  return (
    <RequirePermission permission="facilities.manage">
      <FacilitiesRoute />
    </RequirePermission>
  );
}
